import styled from '@emotion/styled';
import { TableCell } from '@mui/material';
import theme from '../../../../theme';

export const HeaderCell = styled(TableCell)(() => ({
  backgroundColor: theme.palette.info.light,
  borderRight: '1px solid lightGray',
}));
